// TODO: 外部モジュールへの依存を消したい
import { useAllBrandAccountsQuery } from '~/hooks/useAllBrandAccountsQuery'
import { useMeQuery } from '~/hooks/useMeQuery'
import { useRouteParams } from '~/hooks/useRouteParams'

import { useSurveyBrandAccountQuery } from '../useSurveyBrandAccountQuery'

import { useCommonQuery } from './useCommonQuery'

/**
 * useCommonQueryCurrentBrandAccountの解決に必要なクエリ群のいずれかが
 * 取得中かどうかを返すカスタムフックです。
 *
 * これがfalseでもcurrentBrandAccountが解決できない場合は、
 * これ以上待っても解決できない(エラーまたは存在しない)と判断できます。
 *
 * @returns いずれかのクエリが取得中かどうか。
 */
export const useIsLoadingCommonQueryCurrentBrandAccount = () => {
  const { surveyId } = useRouteParams()

  const { isLoading: isLoadingCommonQuery } = useCommonQuery()
  const { isLoading: isLoadingMe } = useMeQuery()
  const { isLoading: isLoadingAllBrandAccounts } = useAllBrandAccountsQuery()
  const { isLoading: isLoadingSurveyBrandAccount } =
    useSurveyBrandAccountQuery(surveyId)

  return (
    isLoadingCommonQuery ||
    isLoadingMe ||
    isLoadingAllBrandAccounts ||
    isLoadingSurveyBrandAccount
  )
}
